// Device-aware responsive layout helper
// Computes CSS variables based on viewport size and aspect ratio to prevent overlaps

export function installResponsiveLayout() {
  const root = document.documentElement;

  const applyVars = () => {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    // Use visualViewport on iOS for accurate height (excludes address bar)
    const vh = window.visualViewport
      ? window.visualViewport.height
      : Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const ar = vw / Math.max(1, vh); // aspect ratio

    // Base CSS variable calculations using clamp for fluid sizing
    const heroPaddingTop = clampPx(vh * 0.07, 48, 160); // 7%vh, min 48px, max 160px
    const heroCardMinH = clampPx(vh * 0.62, 360, 760);  // 62%vh, min 360px, max 760px
    const heroMargin = clampPx(vw * 0.015, 8, 28);      // based on vw
    const activitiesMarginTop = clampPx(vh * 0.02, 8, 24);

    // Aspect-ratio adjustments
    // Very wide screens (ultrawide): reduce hero min-height to avoid pushing content down
    if (ar > 2.0) {
      root.style.setProperty('--hero-card-minh', clampPx(vh * 0.5, 320, 600));
      root.style.setProperty('--hero-padding-top', clampPx(vh * 0.05, 40, 120));
    } else if (ar > 1.6) { // standard widescreen desktops/laptops
      root.style.setProperty('--hero-card-minh', clampPx(vh * 0.56, 340, 680));
      root.style.setProperty('--hero-padding-top', clampPx(vh * 0.06, 44, 136));
    } else if (ar < 0.7) { // tall/portrait (mobiles/foldables)
      root.style.setProperty('--hero-card-minh', clampPx(vh * 0.52, 320, 640));
      root.style.setProperty('--hero-padding-top', clampPx(vh * 0.08, 56, 168));
    } else {
      root.style.setProperty('--hero-card-minh', `${heroCardMinH}px`);
      root.style.setProperty('--hero-padding-top', `${heroPaddingTop}px`);
    }

    root.style.setProperty('--hero-margin', `${heroMargin}px`);
    root.style.setProperty('--activities-margin-top', `${activitiesMarginTop}px`);

    // Safe side padding variable for large screens vs small screens
    const sidePad = clampPx(vw * 0.02, 12, 32);
    root.style.setProperty('--hero-side-padding', `${sidePad}px`);

    // Set --real-vh for iOS Safari (100vh != visible viewport)
    root.style.setProperty('--real-vh', `${vh}px`);
  };

  const clampPx = (value, min, max) => Math.max(min, Math.min(max, Math.round(value)));

  applyVars();
  window.addEventListener('resize', applyVars);
  window.addEventListener('orientationchange', applyVars);
  // iOS Safari fires visualViewport resize when the address bar hides/shows
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', applyVars);
  }

  return () => {
    window.removeEventListener('resize', applyVars);
    window.removeEventListener('orientationchange', applyVars);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', applyVars);
    }
  };
}
